import { Space, SpaceVertical } from '@looker/components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import type { FC } from 'react';
import DotLoader from '../../../../../../components/DotLoader';
import type { ICustomFilter } from '../../../../../../helpers/helpers';
import ChannelRecency from '../ChannelRecency';
import EngagementFilter from '../EngagementFilter';
import useEventFilterManager from '../hooks/useEventFilterManager';
import LinkedFilter from '../LinkedFilter';
import SearchParamsFilter from './SearchParamsFilter';

const Search: FC<ICustomFilter> = ({ onChange }) => {
  const { isLoading, setIsLoading, handleChildChange } = useEventFilterManager({
    filterPrefix: 'search',
    onChange,
  });

  return (
    <SpaceVertical paddingX="u12" paddingTop="u5" gap="u5">
      <EngagementFilter
        onChange={handleChildChange}
        filterId="smart_pixel_match_type_filter"
        filterLabel="Match Type"
        matchTypeFilter
      />
      <SpaceVertical gap="u2" align="stretch">
        <Space gap="u2" align="center">
          <DsTypography variant="label">Tag Collection</DsTypography>
          {isLoading && <DotLoader />}
        </Space>

        <LinkedFilter
          filterName="smart_pixel_collection_filter"
          view="genome_suggestions_hcp365_collection"
          fields={['genome_suggestions_hcp365_collection.collection_name_suggestion']}
          pseudoAdvertiserIdFilterKey="genome_suggestions_hcp365_collection.pseudo_advertiser_id_filter"
          pseudoAccountIdFilterKey="genome_suggestions_hcp365_collection.pseudo_account_id_filter"
          warningMessage="Changing Collection will affect other Collection in Engagement"
          onChange={handleChildChange}
          onLoadingChange={setIsLoading}
        />
      </SpaceVertical>

      <SpaceVertical gap="u2" align="stretch">
        <Space gap="u2" align="center">
          <DsTypography variant="label">Campaign</DsTypography>
          {isLoading && <DotLoader />}
        </Space>

        <LinkedFilter
          filterName="search_campaign_filter"
          view="genome_suggestions_hcp365_campaign"
          fields={['genome_suggestions_hcp365_campaign.campaign_name_suggestion']}
          pseudoAdvertiserIdFilterKey="genome_suggestions_hcp365_campaign.pseudo_advertiser_id_filter"
          pseudoAccountIdFilterKey="genome_suggestions_hcp365_campaign.pseudo_account_id_filter"
          onChange={handleChildChange}
          onLoadingChange={setIsLoading}
        />
      </SpaceVertical>

      <SpaceVertical gap="u2" align="stretch">
        <Space gap="u2" align="center">
          <DsTypography variant="label">Ad Group</DsTypography>
          {isLoading && <DotLoader />}
        </Space>

        <LinkedFilter
          filterName="search_ad_group_filter"
          view="genome_suggestions_hcp365_dsadgroup"
          fields={['genome_suggestions_hcp365_dsadgroup.dsadgroup_suggestion']}
          pseudoAdvertiserIdFilterKey="genome_suggestions_hcp365_dsadgroup.pseudo_advertiser_id_filter"
          pseudoAccountIdFilterKey="genome_suggestions_hcp365_dsadgroup.pseudo_account_id_filter"
          onChange={handleChildChange}
          onLoadingChange={setIsLoading}
        />
      </SpaceVertical>

      <SpaceVertical gap="u2" align="stretch">
        <Space gap="u2" align="center">
          <DsTypography variant="label">Keyword</DsTypography>
          {isLoading && <DotLoader />}
        </Space>

        <LinkedFilter
          filterName="search_keyword_filter"
          view="genome_suggestions_hcp365_search_term"
          fields={['genome_suggestions_hcp365_search_term.search_term_suggestion']}
          pseudoAdvertiserIdFilterKey="genome_suggestions_hcp365_search_term.pseudo_advertiser_id_filter"
          pseudoAccountIdFilterKey="genome_suggestions_hcp365_search_term.pseudo_account_id_filter"
          onChange={handleChildChange}
          onLoadingChange={setIsLoading}
        />
      </SpaceVertical>
      <ChannelRecency onMultiFilterChange={handleChildChange} paddingX="none" />

      <SpaceVertical gap="u5">
        <SearchParamsFilter onChange={handleChildChange} />
      </SpaceVertical>
    </SpaceVertical>
  );
};

export default Search;
